module.exports = __webpack_public_path__ + "static/media/mobileScreenshot01.8e2cf687.jpg";